import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ecb4a52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-container" }
const _hoisted_2 = { class: "filtering-buttons" }
const _hoisted_3 = { class: "dropdown" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "dropdown-content" }
const _hoisted_6 = { class: "search-bar" }
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = { class: "styled-table" }
const _hoisted_9 = {
  key: 0,
  scope: "col"
}
const _hoisted_10 = {
  key: 1,
  scope: "col"
}
const _hoisted_11 = {
  key: 2,
  scope: "col"
}
const _hoisted_12 = {
  key: 3,
  scope: "col"
}
const _hoisted_13 = {
  key: 4,
  scope: "col"
}
const _hoisted_14 = {
  key: 5,
  scope: "col"
}
const _hoisted_15 = {
  key: 6,
  scope: "col"
}
const _hoisted_16 = {
  key: 7,
  scope: "col"
}
const _hoisted_17 = {
  key: 8,
  scope: "col"
}
const _hoisted_18 = {
  key: 9,
  scope: "col"
}
const _hoisted_19 = {
  key: 10,
  scope: "col"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = ["onMouseover"]
const _hoisted_24 = {
  key: 0,
  class: "popover"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { key: 4 }
const _hoisted_28 = { key: 5 }
const _hoisted_29 = { key: 6 }
const _hoisted_30 = { key: 7 }
const _hoisted_31 = { key: 8 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "$", -1))
const _hoisted_33 = { key: 9 }
const _hoisted_34 = { key: 10 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "Delete", -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "8",
  class: "no-tasks-message"
}, [
  /*#__PURE__*/_createElementVNode("h5", null, "No Tasks in this category.")
], -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "pagination-controls" }
const _hoisted_42 = { class: "pagination" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["disabled"]

import UserBadge from '@/components/UserBadge.vue'
import DateTimeBadge from '@/components/DateTimeBadge.vue';
import { ref, onMounted, computed, watch, PropType } from 'vue';
import { Task } from '@/types/Ops';
import { deleteFromUrl } from '@/api/api';
import { useEmployeeStore } from '@/stores/UserEmployee';


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskList',
  props: {
    tasks: {
        type: Array as PropType<Task[]>,
        default: undefined
    },
    visibleColumns: {
        type: Array as PropType<string[]>,
        default: () => ['id', 'name', 'description', 'work_center', 'started', 'concluded', 'total_active_duration', 'labor_cost', 'assigned', 'actions']
    }
},
  setup(__props) {

const props = __props;

const tasks = ref<Task[]>([]);
const employeeStore = useEmployeeStore();

let tasksLoaded = false;
const showDescription = ref(null);
const sortKey = ref('id');
const sortOrder = ref(1);
const searchQuery = ref('');
const initialSerialNumbers = ref({});
const selectedUsername = ref('');
const filterAllTasks = ref(true);
const filterActiveTasks = ref(false);
const filterCompletedTasks = ref(false)
const filterNotStartedTasks = ref(false);
const sortDropdownVisible = ref(false);
const pageSize = ref(15);
const currentPage = ref(1);

const toggleSortDropdown = () => {
    sortDropdownVisible.value = !sortDropdownVisible.value;
};

function updateSort(key) {
    if (sortKey.value === key) {
        sortOrder.value = -sortOrder.value;
    } else {
        sortKey.value = key;
        sortOrder.value = 1;
    }
    sortDropdownVisible.value = false;
}

const truncateDescription = (description) => {
    const maxLength = 50;
    if (description.length > maxLength) {
        return description.substring(0, maxLength) + '...';
    }
    return description;
}

function truncateMilliseconds(durationStr) {
    return durationStr.split('.')[0];
}

const goToPage = (pageNumber) => {
    currentPage.value = pageNumber;
};

const goToPrevPage = () => {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
};

const goToNextPage = () => {
    if (currentPage.value < totalPages.value) {
        currentPage.value++;
    }
};

const paginatedTasks = computed(() => {
    const start = (currentPage.value - 1) * pageSize.value;
    const end = start + pageSize.value;
    return filteredTasks.value.slice(start, end);
});

const totalPages = computed(() => {
    return Math.ceil(filteredTasks.value.length / pageSize.value);
});

const serialNumbers = computed(() => {
    const map = {};
    sortedTasks.value.forEach((task, index) => {
        map[task.id] = index + 1;
    });
    return map;
});

const sortArrow = computed(() => {
    return sortOrder.value === 1 ? '↓' : '↑';
});

const getPriorityClass = (priority) => {
    switch (priority) {
        case 1: return 'low-priority';
        case 2: return 'medium-priority';
        case 3: return 'high-priority';
        default: return '';
    }
};

function durationStringToMilliseconds(durationStr) {
    let totalMilliseconds = 0;

    const parts = durationStr.split(' ');
    const timeParts = parts.pop().split(':');
    const dayPart = parts.pop() || '0';

    totalMilliseconds += parseInt(dayPart, 10) * 24 * 60 * 60 * 1000;
    totalMilliseconds += parseInt(timeParts[0], 10) * 60 * 60 * 1000;
    totalMilliseconds += parseInt(timeParts[1], 10) * 60 * 1000;
    totalMilliseconds += parseFloat(timeParts[2]) * 1000;

    return totalMilliseconds;
}

const userIdToNameMap = computed(() => {
    const map = {};
    employeeStore.employees.forEach(employee => {
        map[employee.user.id] = employee.user.username; // Use 'username' here
    });
    return map;
});


const sortedTasks = computed(() => {
    return tasks.value.slice().sort((a, b) => {
        if (sortKey.value === 'Name') {
            return sortOrder.value * a.name.localeCompare(b.name);
        } else if (sortKey.value === 'Started') {
            if (!a.started && !b.started) {
                return sortOrder.value * (a.id - b.id);
            }
            if (!a.started) return 1;
            if (!b.started) return -1;
            return sortOrder.value * (new Date(a.started).getTime() - new Date(b.started).getTime());
        } else if (sortKey.value === 'Cost') {
            const costA = a.labor_cost ?? 0;
            const costB = b.labor_cost ?? 0;
            return sortOrder.value * (costA - costB);
        } else if (sortKey.value === 'Duration') {
            const durationA = a.total_active_duration ? durationStringToMilliseconds(a.total_active_duration) : 0;
            const durationB = b.total_active_duration ? durationStringToMilliseconds(b.total_active_duration) : 0;
            return sortOrder.value * (durationA - durationB);
        }
        return sortOrder.value * (a.id - b.id);
    });
});

const filteredTasks = computed(() => {
    let filtered = sortedTasks.value;
    if (searchQuery.value) {
        const searchLower = searchQuery.value.toLowerCase();
        filtered = filtered.filter(task => {
            const nameMatch = task.name.toLowerCase().includes(searchLower);
            const descriptionMatch = task.description.toLowerCase().includes(searchLower);
            const workCenterMatch = task.work_center?.name?.toLowerCase().includes(searchLower) || false;
            const jobNameMatch = task.job_name?.toLowerCase().includes(searchLower) || false;
            return nameMatch || descriptionMatch || workCenterMatch || jobNameMatch;
        });
    }
    if (filterActiveTasks.value) {
        filtered = filtered.filter(task => task.started && (task.concluded === null && !task.concluded));
    } else if (filterCompletedTasks.value) {
        filtered = filtered.filter(task => task.concluded !== null && task.concluded !== undefined);
    } else if (filterNotStartedTasks.value) {
        filtered = filtered.filter(task => !task.started && !task.concluded);
    }
    if (selectedUsername.value) {
        filtered = filtered.filter(task =>
            task.assignments.some(assignment =>
                userIdToNameMap.value[assignment.user] === selectedUsername.value
            )
        );
    }
    return filtered;
});

watch(selectedUsername, (newUsername, oldUsername) => {
    console.log(`Username changed from ${oldUsername} to ${newUsername}`);
    // Additional logic can be added here if needed
});


function formatDateTime(dateTimeStr) {
    if (!dateTimeStr) {
        return 'NA';
    }
    const dateObj = new Date(dateTimeStr);
    const date = dateObj.toISOString().split('T')[0];
    const time = dateObj.toTimeString().split(' ')[0];
    return `${date}<br>(${time})`;
}

const setFilterAll = () => {
    filterAllTasks.value = true;
    filterActiveTasks.value = false;
    filterCompletedTasks.value = false;
    filterNotStartedTasks.value = false;
};

const setFilterActive = () => {
    filterAllTasks.value = false;
    filterActiveTasks.value = true;
    filterCompletedTasks.value = false;
    filterNotStartedTasks.value = false;
};

const setFilterCompleted = () => {
    filterAllTasks.value = false;
    filterActiveTasks.value = false;
    filterCompletedTasks.value = true;
    filterNotStartedTasks.value = false;
};

const setFilterNotStarted = () => {
    filterAllTasks.value = false;
    filterActiveTasks.value = false;
    filterCompletedTasks.value = false;
    filterNotStartedTasks.value = true;
};

const deleteTask = async (taskId, index) => {
    if (confirm('Are you sure you want to delete this task?')) {
        try {
            await deleteFromUrl(`/ops/api/tasks/${taskId}/`);
            tasks.value.splice(index, 1);
        } catch (error) {
            console.error('Failed to delete task from backend:', error);
        }
    }
};

onMounted(() => {
    if (props.tasks) {
        tasks.value = props.tasks.filter(task => !task.name.includes("template"));
        tasks.value = [...props.tasks].sort((a, b) => a.id - b.id);
        tasks.value.forEach((task, index) => {
            initialSerialNumbers.value[task.id] = index + 1;
        });
        tasksLoaded = true;
    } else {
        // console.error("Tasks are not provided or undefined!");
    }
    employeeStore.fetch();
});

watch(() => props.tasks, (newTasks) => {
    if (newTasks) {
        tasks.value = newTasks.filter(task => !task.name.includes("template"));
        tasks.value = tasks.value.sort((a, b) => a.id - b.id);
        initialSerialNumbers.value = {};
        tasks.value.forEach((task, index) => {
            initialSerialNumbers.value[task.id] = index + 1;
        });
    }
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["apple-button all-tasks", { 'active-filter': filterAllTasks.value }]),
        onClick: setFilterAll
      }, " Show All Tasks ", 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["apple-button completed-task", { 'active-filter': filterCompletedTasks.value }]),
        onClick: setFilterCompleted
      }, " Completed Tasks ", 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["apple-button active-task", { 'active-filter': filterActiveTasks.value }]),
        onClick: setFilterActive
      }, " Active Tasks ", 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["apple-button not-started-task", { 'active-filter': filterNotStartedTasks.value }]),
        onClick: setFilterNotStarted
      }, " Not Started ", 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "apple-button sort-button",
          onClick: toggleSortDropdown
        }, [
          _createTextVNode(" Sort By "),
          (sortKey.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(sortKey.value) + " " + _toDisplayString(sortArrow.value), 1))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "apple-button id",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (updateSort('Id')))
          }, "Id"),
          _createElementVNode("button", {
            class: "apple-button name",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (updateSort('Name')))
          }, "Name"),
          _createElementVNode("button", {
            class: "apple-button started",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (updateSort('Started')))
          }, "Started"),
          _createElementVNode("button", {
            class: "apple-button cost",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (updateSort('Cost')))
          }, "Cost"),
          _createElementVNode("button", {
            class: "apple-button duration",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (updateSort('Duration')))
          }, "Duration")
        ], 512), [
          [_vShow, sortDropdownVisible.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("input", {
        class: "search-input",
        type: "text",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchQuery).value = $event)),
        placeholder: "Search Name of Task, Description, Work Center or the Job Name..."
      }, null, 512), [
        [_vModelText, searchQuery.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("table", _hoisted_8, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (__props.visibleColumns.includes('id'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_9, "Sr. No."))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('name'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_10, "ID | Task"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('description'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Description"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('job_name'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_12, "Job Name"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('work_center'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_13, "Work Center"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('started'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_14, "Start Date"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('concluded'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_15, "End Date"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('total_active_duration'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_16, "ActiveDuration"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('labor_cost'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_17, "Labor Cost"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('assigned'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_18, "Assigned To"))
              : _createCommentVNode("", true),
            (__props.visibleColumns.includes('actions'))
              ? (_openBlock(), _createElementBlock("th", _hoisted_19, "Actions"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (paginatedTasks.value.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(paginatedTasks.value, (task, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: task.id,
                  class: _normalizeClass(getPriorityClass(task.priority))
                }, [
                  (__props.visibleColumns.includes('id'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(initialSerialNumbers.value[task.id]), 1))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('name'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(task.id) + " | " + _toDisplayString(task.name), 1))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('description'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                        _createElementVNode("div", {
                          class: "task-description",
                          onMouseover: ($event: any) => (showDescription.value = task.id),
                          onMouseout: _cache[6] || (_cache[6] = ($event: any) => (showDescription.value = null))
                        }, [
                          _createTextVNode(_toDisplayString(truncateDescription(task.description)) + " ", 1),
                          (showDescription.value === task.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createTextVNode("Task Description:"),
                                _hoisted_25,
                                _createTextVNode(_toDisplayString(task.description), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 40, _hoisted_23)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('job_name'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(task.job_name ? task.job_name : 'N/A'), 1))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('work_center'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(task.work_center ? task.work_center.name : 'Not Available'), 1))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('started'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                        _createVNode(DateTimeBadge, {
                          time: task.started
                        }, null, 8, ["time"])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('concluded'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_29, [
                        _createVNode(DateTimeBadge, {
                          time: task.concluded
                        }, null, 8, ["time"])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('total_active_duration'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(truncateMilliseconds(task.total_active_duration)), 1))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('labor_cost'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                        _hoisted_32,
                        _createTextVNode(" " + _toDisplayString(task.labor_cost), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('assigned'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task.assignments, (assignment) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: assignment.id
                          }, [
                            _createVNode(UserBadge, {
                              "user-id": assignment.user
                            }, null, 8, ["user-id"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (__props.visibleColumns.includes('actions'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                        _createVNode(_component_router_link, {
                          class: "apple-button view-button",
                          to: { name: 'task-view', params: { id: task.id } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("View")
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        (_unref(employeeStore).currentUser.user?.is_superuser || _unref(employeeStore).currentUser.user?.is_staff)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "apple-button delete-button",
                              onClick: ($event: any) => (deleteTask(task.id, index))
                            }, _hoisted_37, 8, _hoisted_35))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            : (_openBlock(), _createElementBlock("tr", _hoisted_38, _hoisted_40))
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_41, [
      _createElementVNode("ul", _hoisted_42, [
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: currentPage.value === 1 }])
        }, [
          _createElementVNode("button", {
            class: "page-link",
            onClick: goToPrevPage,
            disabled: currentPage.value === 1
          }, "Previous", 8, _hoisted_43)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["page-item", { active: currentPage.value === page }]),
            key: page
          }, [
            _createElementVNode("button", {
              class: "page-link",
              onClick: ($event: any) => (goToPage(page))
            }, _toDisplayString(page), 9, _hoisted_44)
          ], 2))
        }), 128)),
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: currentPage.value === totalPages.value }])
        }, [
          _createElementVNode("button", {
            class: "page-link",
            onClick: goToNextPage,
            disabled: currentPage.value === totalPages.value
          }, "Next", 8, _hoisted_45)
        ], 2)
      ])
    ])
  ]))
}
}

})